import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import { ModalBody, Tabs, Content, Description, Questions } from './styled';
import { Gem1, Gem2, Gem3, Gem4, Gem5, PreviewInfoIcon, PreviewDemoIcon } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import Resources from '../../helpers/resources';
import { getQueryParam, getConfiguration } from '../../helpers/utils';

function UpfAssignModal({ previewInfo, i18n, viewDemo, isLoading, previewError }) {
  if (isLoading) return <div />;
  if (previewError) return <div>{previewError}</div>;

  const baseUrl = getConfiguration('UPFBaseUrl');
  const [activeClass, setActiveClass] = useState(1);
  const [showPreviewCallout, setPreviewCallout] = useState(false);
  const gems = [];
  const stepsIntialAndIncrement = 1;
  const {
    learningJourneyName = '',
    standardCode = '',
    standardDescription = '',
    standardName = '',
    steps = []
  } = previewInfo || {};
  const { spineName = '', subNodeNames = [] } =
    (steps && steps[activeClass - 1] && steps[activeClass - 1].spines && steps[activeClass - 1].spines[0]) || {};
  // eslint-disable-next-line max-len
  const iframeSrc = `${baseUrl.replace('?', '')}qtc-preview?authToken=${Resources.env.authToken}&locale=${getQueryParam('locale') || 'en-AU'}&girlId=${steps[activeClass - 1].spines[0].exampleGirlId}` || ''

  for (let count = stepsIntialAndIncrement; count <= steps.length; count += stepsIntialAndIncrement) {
    let stepIcon = null;
    switch (count) {
      case 1:
        stepIcon = Gem1;
        break;
      case 2:
        stepIcon = Gem2;
        break;
      case 3:
        stepIcon = Gem3;
        break;
      case 4:
        stepIcon = Gem4;
        break;
      case 5:
        stepIcon = Gem5;
        break;
      default:
        break;
    }
    gems.push(
      <button className={activeClass === count ? 'active' : ''} onClick={() => setActiveClass(count)}>
        <SvgIcon icon={stepIcon} />
      </button>
    );
  }

  return (
    <ModalBody>
      <div className="title">{learningJourneyName}</div>
      <Tabs>
        <div className="header">
          <span className="subTitle">{i18n.t`STEP`}</span>
          {gems}
        </div>
        <div>
          <Button
            alignIcon="LEFT"
            className="previewButton"
            icon={PreviewInfoIcon}
            onClick={() => setPreviewCallout(true)}
            primary
            text={i18n.t`Whats's this`}
            type={Button.LOZENGE}
          />
          <OutsideClickHandler callback={() => setPreviewCallout(false)} forButton="previewButton">
            {showPreviewCallout && (
              <span className="whatsThisCallout">
                {i18n.t`The activity name displayed top-left is 
                the name of the Skill Quest. Each Skill Quest has a number of steps
                (referred to as Levels in the student view).`}
                <br />
                <br />
                {i18n.t`Click on the Step tabs to view the types of questions for each step. 
                To see the interactive student view of the Step you are viewing, 
                click on the "View demo in new tab" button.`}
              </span>
            )}
          </OutsideClickHandler>
        </div>
      </Tabs>
      <Content>
        <Description>
          <div>
            <span onClick={viewDemo} role="button" tabIndex="0" className="demo">
              <Button
                alignIcon="LEFT"
                className="previewButton"
                icon={PreviewDemoIcon}
                onClick={() => {}}
                primary
                text={i18n.t`View demo in new tab`}
                type={Button.LOZENGE}
              />
            </span>
          </div>
          <div className="stepDetails">
            <div className="heading">{i18n.t`Step ${activeClass} Covers:`}</div>
            <div className="subHeading">{spineName}</div>
            <ul className="list">{subNodeNames && subNodeNames.map(node => <li>{node}</li>)}</ul>
          </div>
          <div className="descriptions">
            <div className="heading">{i18n.t`Activity Description`}</div>
            <div className="subHeading">{standardName}</div>
            <div className="subHeading">
              {standardCode ? `${standardCode}: ` : ''}
              {standardDescription}
            </div>
            <div className="subHeading">{learningJourneyName}</div>
          </div>
        </Description>
        <Questions>
          <iframe
            src={iframeSrc}
            title="UPF single question example"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin"
          />
        </Questions>
      </Content>
    </ModalBody>
  );
}

export function createAssignModal(previewInfo, i18n, viewDemo, isLoading, previewError) {
  return {
    content: (
      <UpfAssignModal
        previewInfo={previewInfo}
        i18n={i18n}
        viewDemo={viewDemo}
        isLoading={isLoading}
        previewError={previewError}
      />
    ),
    id: 0,
    buttons: []
  };
}

UpfAssignModal.propTypes = {
  previewInfo: PropTypes.object,
  i18n: PropTypes.object,
  viewDemo: PropTypes.func,
  isLoading: PropTypes.bool,
  previewError: PropTypes.string
};

export default UpfAssignModal;
